import { Container, Box } from "@mui/material";
import { FormattedMessage } from "react-intl";
import Plans from "../components/Plans/Plans";

// Public pricing page: the plans of kizwork.com/pricing, the Subscribe buttons
// go to the Checkout (/billing/checkout), which asks to log in or register
// first.
const Pricing = () => (
  <Container>
    <h1>
      <FormattedMessage id="pricing.pricing-title" defaultMessage="Pricing" />
    </h1>
    <Box sx={{ mt: 3, mb: 4 }}>
      <Plans />
    </Box>
  </Container>
);

export default Pricing;
